import image1 from "./components/images/image1.jpg";
import image2 from "./components/images/image2.jpg";
import image3 from "./components/images/image3.jpg";
import image4 from "./components/images/image4.jpg";
import image5 from "./components/images/image5.jpg";
import image6 from "./components/images/image6.jpg";

import image7 from "./components/images/image7.jpg";
import image8 from "./components/images/image8.jpg";
import image9 from "./components/images/image9.jpg";
import image10 from "./components/images/image10.jpg";
import image11 from "./components/images/image11.jpg";
import image12 from "./components/images/image12.jpg";

import image13 from "./components/images/image19.jpg";
import image14 from "./components/images/image20.jpg";
import image15 from "./components/images/image21.jpg";
import image16 from "./components/images/image22.jpg";
import image17 from "./components/images/image23.jpg";
import image18 from "./components/images/image24.jpg";
import image19 from "./components/images/image25.jpg";

import image20 from "./components/images/image26.jpg";
import image21 from "./components/images/image27.jpg";
import image22 from "./components/images/image28.jpg";
import image23 from "./components/images/image29.jpg";
import image24 from "./components/images/image30.jpg";
import image25 from "./components/images/image31.jpg";
import image26 from "./components/images/image32.jpg";
import image27 from "./components/images/newGown.jpeg";
import image28 from "./components/images/newgown1.jpeg";
import image29 from "./components/images/image33.jpg";

const DUMMY_DATA = [
  {
    id: "s1",
    name: "Vintage Shirt",
    description:
      "a light weight, beachy vibe vintage for excellent vacation, hiking and beaching experience",
    prevPrice: 12000,
    price: 9600,
    size: "2XL, L",
    image: image1,
    type: "shirt",
    featured: true,
    slug: "vintage-shirt",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s2",
    name: "Men Fitted Plain Trousers",
    description:
      "This is all you need to kill every outings look. The men fitted plain trousers gives you the simple but exquisite look. It lets you rock occasions in grand style showing your top notch fashion sense.",
    prevPrice: 12000,
    price: 9600,
    size: "XL, L",
    image: image2,
    type: "trouser",
    featured: true,
    slug: "Men-Fitted-Plain-Trousers",
    soldOut: true,
    discount: 20,
  },
  {
    id: "s3",
    name: "Shoulder Slitted Crop Top",
    description:
      "This sleeveless doesn't merely get you dressed up, but dressed to impress. Showing up in parties/club, casual outings looking all classy and mouth drooling.",
    prevPrice: 3500,
    price: 3150,
    size: "SM, M",
    image: image3,
    type: "shirts",
    featured: true,
    slug: "Shoulder-Slitted-Crop-Top",
    soldOut: false,
    discount: 10,
  },
  {
    id: "s4",
    name: "Women Pleated Office Gown",
    description:
      "Smash that office or formal look with this styled, well pleated gown!. Never miss the comfort you deserve while sitting pretty and trendy behind that office desk. Looking all sophisticated and good with the v-neck cut down a little above the cleavage.",
    prevPrice: 12000,
    price: 9600,
    image: image4,
    type: "gown",
    featured: true,
    slug: "women-pleated-office-gown",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s5",
    name: "Nature's Print Vintage Shirt",
    description:
      "It's made from high quality nature print fabric with standard thickness and long durability. It blends perfectly into your manly frame giving you a classy and unique look.",
    prevPrice: 12000,
    price: 9600,
    size: "XL",
    image: image5,
    type: "shirts",
    featured: true,
    slug: "Nature's-Print-vintage-shirt",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s6",
    name: "Party Gown",
    description:
      "Neatly Tailored to suit every elegant lady style and taste. Bless every occasion with glamour with this trendy quality outfit.",
    prevPrice: 12000,
    price: 9600,
    size: "M, L",
    image: image6,
    type: "gown",
    featured: true,
    slug: "Party Gown 1",
    soldOut: false,
    discount: 20,
  },

  {
    id: "s7",
    name: "Unisex Slides",
    description:
      "Don't miss the opportunity to remain all classy, unique and stylish even in casual wears. Adorn your feet with this piece.",
    prevPrice: 8000,
    price: 6400,
    size: "38/39, 42/43, 46/47, L",
    image: image7,
    type: "sandals",
    slug: "unisex-slides",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s8",
    name: "Vintage Shirt",
    description:
      "It's made from high quality nature print fabric with standard thickness and long durability. It blends perfectly into your manly frame giving you a classy and unique look.",
    prevPrice: 12000,
    price: 9600,
    size: "2XL",
    image: image8,
    type: "shirts",
    slug: "Vintage Shirt 1",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s9",
    name: "Men Fitted Plain Trousers",
    description:
      "This is all you need to kill every outings. The men fitted plain trousers gives you the simple but exquisite look. It lets you rock occasions in grand style showing your top notch fashion sense. ",
    prevPrice: 12000,
    price: 9600,
    size: "L, XL",
    image: image9,
    type: "trouser",
    featured: true,
    slug: "men-fitted-plain-trouser-black",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s10",
    name: "Vintage Shirt",
    description:
      "It's made from high quality nature print fabric with standard thickness and long durability. It blends perfectly into your manly frame giving you a classy and unique look.",
    prevPrice: 12000,
    price: 9600,
    size: "XL",
    image: image10,
    type: "shirts",
    slug: "Vintage Shirt 2",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s11",
    name: "Crossed Back Crop Top",
    description:
      "Never miss an opportunity to add this quality, trendy and classy piece to your outfit collection. Step out in this piece looking like a hot classy chic!!. Get into that party looking all trendy and vogue in this crop top with the rope tied around your waist.",
    prevPrice: 3500,
    price: 3150,
    size: "SM, M",
    image: image11,
    type: "shirts",
    slug: "crossed-back-crop-top",
    soldOut: false,
    discount: 10,
  },
  {
    id: "s12",
    name: "Women Pleated Office Gown",
    description:
      "Smash that office or formal look with this styled, well pleated gown!. Never miss the comfort you deserve while sitting pretty and trendy behind that office desk. Looking all sophisticated and good with the v-neck cut down a little above the cleavage. ",
    prevPrice: 12000,
    price: 9600,
    image: image12,
    size: "2XL, L",
    type: "gown",
    featured: true,
    slug: "Women-Pleated-Office-Gown",
    soldOut: false,
    discount: 20,
  },

  {
    id: "s13",
    name: "Male Ripped Jeans",
    description:
      "Step out for outings with the most distinct style and fashion. Be that man that steals the glance of every lady upon showing up!.",
    prevPrice: 13000,
    price: 10400,
    size: "L",
    image: image13,
    type: "trouser",
    slug: "Male Ripped Jeans 4",
    soldOut: false,
    discount: 20,
  },

  {
    id: "s14",
    name: "Male Ripped Jeans",
    description:
      "Step out for outings with the most distinct style and fashion. Be that man that steals the glance of every lady upon showing up!.",
    prevPrice: 15000,
    price: 12000,
    size: "L",
    image: image14,
    type: "trouser",
    slug: "Male Ripped Jeans 3",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s15",
    name: "Male Ripped Jeans",
    description:
      "Step out for outings with the most distinct style and fashion. Be that man that steals the glance of every lady upon showing up!.",
    prevPrice: 15000,
    price: 12000,
    size: "L",
    image: image15,
    type: "trouser",
    slug: "Male Ripped Jeans 2",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s16",
    name: "Karl Lagerfeld Sandals",
    description:
      "Looking for style and great value for your money? Get this Karl Lagerfeld sandals!. Stay all elegant and trendy with style. Give your outfit complete exquisite look with the Karl Lagerfeld sandals.",
    prevPrice: 18000,
    price: 14400,
    size: "42",
    image: image16,
    type: "sandals",
    slug: "Karl-Lagerfeld-Sandals",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s17",
    name: "Female High Waist Ripped Jeans",
    description:
      "Stay unique and classy. Well tailored to slimfit and trim all waist line. Perfect fit for both slim and thick ladies.",
    prevPrice: 12000,
    price: 9600,
    size: "L",
    image: image17,
    type: "trouser",
    slug: "Female High Waist Ripped Jeans",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s18",
    name: "Male Ripped Jeans",
    description:
      "Step out for outings with the most distinct style and fashion. Be that man that steals the glance of every lady upon showing up!.",
    prevPrice: 15000,
    price: 12000,
    size: "L",
    image: image18,
    type: "trouser",
    slug: "Male Ripped Jeans 1",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s19",
    name: "Dolce and Gabbana Luxury Shorts",
    description:
      "Remain simple and luxurious at the same time!. Take your casual outings to the next level of uniqueness and class with this piece. Rock your beach day with the newest trend and style.",
    prevPrice: 10000,
    price: 8000,
    image: image19,
    size: "2XL, L",
    type: "trouser",
    slug: "Dolce-and-gabbana-luxury-short",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s20",
    name: "Black Gown",
    description:
      "Neatly Tailored to suit every elegant lady style and taste. Bless every occasion with glamour with this trendy quality outfit.",
    prevPrice: 7000,
    price: 5600,
    size: "L",
    image: image20,
    type: "gown",
    slug: "Black Gown",
    soldOut: false,
    discount: 20,
  },

  {
    id: "s21",
    name: "Lace Up Unisex Trainers",
    description:
      "Complete your outfit with this luxury. Appear all good and trendy with this foot wear in all occassions.",
    prevPrice: 20000,
    price: 14000,
    size: 44,
    image: image21,
    type: "sandals",
    slug: "Lace-Up-Unisex-Trainers",
    soldOut: false,
    discount: 30,
  },
  {
    id: "s22",
    name: "Lace Up Unisex Trainers",
    description:
      "Complete your outfit with this luxury. Appear all good and trendy with this foot wear in all occassions.",
    prevPrice: 20000,
    price: 14000,
    size: 40,
    image: image22,
    type: "sandals",
    slug: "Lace Up Unisex Trainers-black",
    soldOut: false,
    discount: 30,
  },
  {
    id: "s23",
    name: "Female High Waist Ripped Jeans",
    description:
      "Stay unique and classy. Well tailored to slimfit and trim all waist line. Perfect fit for both slim and thick ladies.",
    prevPrice: 12000,
    price: 9600,
    size: "L",
    image: image23,
    type: "trouser",
    slug: "Female High Waist Ripped Jeans black",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s24",
    name: "Cross Strap Sandal Heels",
    description:
      "Made from premium quality leather that doesn't peel off easily. An exclusive design for the BOSS!.",
    prevPrice: 15000,
    price: 10500,
    size: 39,
    image: image24,
    type: "sandals",
    slug: "Cross Strap Sandal Heels",
    soldOut: false,
    discount: 20,
  },

  {
    id: "s25",
    name: "Air Jordan 4 Retro Sneakers",
    description:
      "Adorn your feet with this master piece. Spice up your outfit with this eye catchy luxury.",
    prevPrice: 30000,
    price: 21000,
    size: 40,
    image: image25,
    type: "sandals",
    slug: "Air-jordan-4-retro-sneakers",
    soldOut: false,
    discount: 30,
  },
  {
    id: "s26",
    name: "Multicolored Short Sleeve Vintage Shirt",
    description:
      "The most preferred piece to rock your outing with glamour and vogue fashion style. Made from high quality, highly durable material!.",
    prevPrice: 12000,
    price: 9600,
    size: "L",
    image: image26,
    type: "shirts",
    slug: "multicolored-short-sleeve-vintage-shirt",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s27",
    name: "Party Gown",
    description:
      "Neatly Tailored to suit every elegant lady style and taste. Bless every occasion with glamour with this trendy quality outfit.",
    prevPrice: 10000,
    price: 8000,
    size: "L",
    image: image27,
    type: "gown",
    slug: "sky blue Gown",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s28",
    name: "Party Gown",
    description:
      "Neatly Tailored to suit every elegant lady style and taste. Bless every occasion with glamour with this trendy quality outfit.",
    prevPrice: 10000,
    price: 8000,
    size: "L",
    image: image28,
    type: "gown",
    slug: "deep blue Gown",
    soldOut: false,
    discount: 20,
  },
  {
    id: "s29",
    name: "Party Gown",
    description:
      "Neatly Tailored to suit every elegant lady style and taste. Bless every occasion with glamour with this trendy quality outfit.",
    prevPrice: 10000,
    price: 8000,
    size: "L",
    image: image29,
    type: "gown",
    slug: "white gown",
    soldOut: true,
    discount: 20,
  },
];

export function isSoldOut() {
  return DUMMY_DATA.map((data) => data.soldOut);
}

export function getShirts() {
  const filteredShirts = DUMMY_DATA.filter((data) => data.type === "shirts");
  return filteredShirts;
}

export function getTrousers() {
  const filteredTrousers = DUMMY_DATA.filter((data) => data.type === "trouser");
  return filteredTrousers;
}

export function getFeaturedItems() {
  const featuredItems = DUMMY_DATA.filter((data) => data.featured);

  return featuredItems;
}

export function getGowns() {
  const filteredGowns = DUMMY_DATA.filter((data) => data.type === "gown");
  return filteredGowns;
}

export function getCroptop() {
  const filteredCroptop = DUMMY_DATA.filter((data) => data.type === "croptop");
  return filteredCroptop;
}

export function getShoes() {
  const filteredShoes = DUMMY_DATA.filter((data) => data.type === "sandals");
  return filteredShoes;
}

// export function getStoreDetails(id) {
//   const storeDetails = DUMMY_DATA.find((data) => data.id === id);
//   return storeDetails;
// }

export function getSlugDetails(slug) {
  const storeDetails = DUMMY_DATA.find((data) => data.slug === slug);
  return storeDetails;
}

function getProductData(id) {
  let productData = DUMMY_DATA.find((product) => product.id === id);

  if (productData === undefined) {
    console.log("Product data does not exist");
    return undefined;
  }

  return productData;
}

export { DUMMY_DATA, getProductData };
